import FieldDropdown from "../../../../fields3/generic/dropdown/dropdown"
import ContactTypePopoverMenuMore from "./components/popover-menu-more"
import FieldConfig from "../../../proto/field-config"
import FieldContactType_GlistGroupStandard from "./components/glist-group/standard"

export default class FieldCrmContactType extends FieldDropdown {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel = "Crm Contact Type"

        this.options            = gd.company.settings.modules.crmContact.contactTypes;

        // if true will add no value option to options list (by default true for custom fields)
        this.noValueOption      = _.get(config,'addNoValueOption',true);

        // Label for no value option
        this.noValueOptionLabel = _.get(config,'noValueOptionLabel','Not specified');

        // default placeholder for FORM element
        this.placeholder        = _.get(config,'placeholder','Please select');

        this.icon = 'i5-crm-contact';

        this.isSearchable = true;

        this.components = _.assign({}, this.components, {
            PopoverMenuMore     : ContactTypePopoverMenuMore,

            glistGroupStandard  : FieldContactType_GlistGroupStandard
        })
    }

    groupValue(value:any) {
        return _.get(this._getOption(value),'value', null);
    }

    groupSortValue(value:any) {
        return _.indexOf(this.options, this._getOption(value));
    }

}
